import { Component, OnInit, ViewChild, ElementRef, HostListener, AfterViewInit, Input } from '@angular/core';
import { NeoAdvertisement } from '@sparro/app/core/models/ads.model';

@Component({
  selector: 'uni-advertisement-card',
  templateUrl: './advertisement-card.component.html',
  styleUrls: ['./advertisement-card.component.scss']
})
export class AdvertisementCardComponent implements OnInit, AfterViewInit {
  @ViewChild ('adContainer') container: ElementRef;
  @Input() advertisement: NeoAdvertisement;
  imageHeight: number;
  imageWidth: number;

  constructor() { }

  ngOnInit(): void {
  }
  
  ngAfterViewInit(): void {
    this.onWindowResize();
  }

  @HostListener('window:resize', [])
  @HostListener('window:scroll', [])
  onWindowResize(): void {
    this.imageWidth = this.container?.nativeElement.offsetWidth;
    this.imageHeight = this.imageWidth / (this.container?.nativeElement.offsetWidth > 960 ? 4.31 : 
      this.container?.nativeElement.offsetWidth > 540 ? 3.76 : 1);
  }
}
